/**
 * Safely escape HTML to prevent XSS attacks
 */
window.escapeHtml = function(unsafe) {
    if (typeof unsafe !== 'string') {
        return '';
    }
    
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
};

/**
 * Create text node safely (alternative to escaping)
 */
window.createTextElement = function(tagName, text, className) {
    var element = document.createElement(tagName);
    element.textContent = text || '';
    if (className) {
        element.className = className;
    }
    return element;
};